/** What the error page tells RowCall about a crash (apps/platform/src/controllers/clientErrors.ts). */
export type ClientErrorReport = { reference: string; message: string; path: string; stack?: string }

/**
 * Tells RowCall's logs about a crash, best effort: the page is already broken, so a failed report is let go (the
 * person can still email the reference). The platform answers 204, no body, so this doesn't go through apiRequest.
 */
export const reportClientError = async (report: ClientErrorReport): Promise<void> => {
  try {
    await fetch('/api/client-errors', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(report),
      signal: AbortSignal.timeout(5000),
    })
  } catch {
    // Offline, or the platform is down too: the reference on screen is enough to find it later.
  }
}
